import { render, staticRenderFns } from "./PrintingGroup.vue?vue&type=template&id=c2ae3dd0&lang=pug"
import script from "./PrintingGroup.vue?vue&type=script&lang=js"
export * from "./PrintingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports